import { createEpicMiddleware, EpicMiddleware } from "redux-observable";
import { createLogger } from "redux-logger";
import {
    applyMiddleware,
    createStore,
    compose,
    Store,
    StoreEnhancer,
} from "redux";
import { rootReducer } from "src/redux/reducer";
import { rootEpic } from "src/redux/epic";
import { AppState } from "src/redux/state";

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: Function;
        v1ReplaceState: () => void;
        v1GoHome: () => void;
    }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const USE_REDUX_LOGGER = process.env.REACT_APP_USE_REDUX_LOGGER === "on";

const epicMiddleware = createEpicMiddleware();

const getMiddleware = (): StoreEnhancer => {
    const middlewares = [epicMiddleware];
    if (process.env.NODE_ENV !== "production" && USE_REDUX_LOGGER) {
        middlewares.push(createLogger() as EpicMiddleware<any>);
    }
    return applyMiddleware(...middlewares);
};
const configureStore = (): Store<AppState> => {
    return createStore(rootReducer, {}, composeEnhancers(getMiddleware()));
};

const store = configureStore();

epicMiddleware.run(rootEpic);

export { store };
